// ======================================================================
// File Name       : SelectUsersContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { change, getFormValues } from 'redux-form';
import { Form } from 'react-bootstrap';
import RenderField from '../../utils/ReduxFormUtils';
import Header from '../../components/Header';
import UserSearchOnDialog from '../../components/user/UserSearchOnDialog';
import UserListOnDialog from '../../components/user/UserListOnDialog';
import * as UserAction from '../../actions/UserAction';
import * as GroupAction from '../../actions/GroupAction';
import * as AuthorityAction from '../../actions/AuthorityAction';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../constants/index';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { USER_CREATE_TYPE, USER_TYPE } from '../../constants/UserConstants';
import { SERVICE_USER_TYPE } from '../../constants/ServiceConstant';
import { editDistributionList } from '../../actions/ContentDistributionAction';
import { checkUserChecked, isSuperUser } from '../../utils/index';
import store from '../../store';

class SelectUsersContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allUserSelected: [],
    };
    this.selectSingleUser = this.selectSingleUser.bind(this);
    this.addUsersToList = this.addUsersToList.bind(this);
    this.searchUser = this.searchUser.bind(this);
    this.searchUserOnSubmit = this.searchUserOnSubmit.bind(this);
    this.initData = this.initData.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.removeSelectedGroup = this.removeSelectedGroup.bind(this);
    this.checkUncheckAllUsersOnPage = this.checkUncheckAllUsersOnPage.bind(this);
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
  }

  componentWillMount() {
    const { parentFormValues } = this.props;
    this.props.dispatch(GroupAction.removeSelectedGroup());
    this.initData().then(() => {
      if (parentFormValues && parentFormValues.storedEdittingUserList) {
        const storedEdittingUserListArray = Object.keys(parentFormValues.storedEdittingUserList);
        const allUserSelected = storedEdittingUserListArray.reduce((acc, cur) => {
          if (cur) {
            acc.push(cur);
          }
          return acc;
        }, []);
        this.setState({ allUserSelected });
      }
    });
  }

  componentWillUnmount() {
    this.props.dispatch(UserAction.removedUserOnDialog());
  }

  initData() {
    const {
      userType,
      authorityInfo,
      withAuthority,
      additionalSearchInfo,
      shouldAddSearchInfo,
    } = this.props;
    let paramSearchInfo = {
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
    };
    if (additionalSearchInfo && Object.keys(additionalSearchInfo).length && shouldAddSearchInfo) {
      paramSearchInfo = {
        ...additionalSearchInfo,
        startPosition: 0,
        returnMaxNum: RETURN_MAX_NUM,
      };
    }
    !isNaN(parseInt(userType, 10)) && (paramSearchInfo.userType = userType);
    const paramSearchAttribute = null;
    const emptyAuthorityInfo =
      !authorityInfo ||
      !authorityInfo.bySecernId ||
      !authorityInfo.managementAuthorityList ||
      !authorityInfo.managementAuthorityList.length;
    // Step 11.0.0 START
    if (userType === null) { // ライブ開催者
      paramSearchInfo.userCreateType = USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER; //STEP11.1.1 allow show new admin
    }
    // Step 11.0.0 END
    if (userType === SERVICE_USER_TYPE.USAGE_SCREEN && emptyAuthorityInfo && withAuthority) {
      return this.props.dispatch(AuthorityAction.getAuthorityList()).then(() => {
        this.props.dispatch(
          UserAction.searchUserOnDialog({ paramSearchInfo, paramSearchAttribute }, false),
        );
      });
    } else {
      return this.props.dispatch(UserAction.searchUserOnDialog({ paramSearchInfo, paramSearchAttribute }, false));
    }
  }

  searchUser(startPosition, column) {
    const { formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const param = this.createParams(formValues, startPosition, column);
    this.props.dispatch(UserAction.searchUserOnDialog(param));
  }

  createParams(searchInfo, startPosition, column) {
    const { userType, additionalSearchInfo, shouldAddSearchInfo } = this.props;
    let paramSearchInfo = {};
    if (additionalSearchInfo && Object.keys(additionalSearchInfo).length && shouldAddSearchInfo) {
      paramSearchInfo = {
        ...additionalSearchInfo,
      };
    }
    const paramSearchAttribute = {};
    paramSearchInfo.returnMaxNum = RETURN_MAX_NUM;
    !isNaN(parseInt(userType, 10)) && (paramSearchInfo.userType = userType);
    if (searchInfo && Object.keys(searchInfo).length) {
      searchInfo.loginId && (paramSearchInfo.loginId = searchInfo.loginId);
      searchInfo.userName && (paramSearchInfo.userName = searchInfo.userName);
      userType === SERVICE_USER_TYPE.USAGE_SCREEN &&
        searchInfo.managementAuthoritySecernId &&
        (paramSearchInfo.managementAuthorityList = [searchInfo.managementAuthoritySecernId]);
      paramSearchInfo.startPosition = searchInfo.startPosition || 0;
      searchInfo.selectedTargetGroup &&
        searchInfo.selectedTargetGroup.groupSecernId &&
        (paramSearchInfo.groupList = [searchInfo.selectedTargetGroup.groupSecernId]);

      searchInfo.userAttributeKeyNum &&
        (paramSearchAttribute.userAttributeKeyNum = searchInfo.userAttributeKeyNum);
      searchInfo.userAttributeSearchText &&
        (paramSearchAttribute.userAttributeSearchText = searchInfo.userAttributeSearchText);
    }
    if (!isNaN(parseInt(startPosition, 10))) {
      paramSearchInfo.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      paramSearchInfo.ascendingDescendingSort = column.sortState;
      paramSearchInfo.messageSortType = column.sortBy;
    }
    // Step 11.0.0 START
    if (userType === null) { // ライブ開催者
      paramSearchInfo.userCreateType = USER_CREATE_TYPE.DEFINED_AND_REPRESENTATIVE_USER;
    }
    // Step 11.0.0 END
    return { paramSearchInfo, paramSearchAttribute };
  }

  getStartEndData(startPosition) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchUser(startPosition);
  }

  handleSortState(column) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchUser(null, column);
  }

  searchUserOnSubmit(values) {
    const { invalid } = this.props;
    if (invalid || !values) {
      return;
    }
    const param = this.createParams(values, null, null);
    this.props.dispatch(UserAction.searchUserOnDialog(param));
  }

  addUsersToList() {
    const { edittingUserList, dispatch, hideModal, addUsersToList } = this.props;
    if (edittingUserList && Object.keys(edittingUserList).length) {
      const userList = Object.keys(edittingUserList).reduce((acc, cur) => {
        const isShouldAdd = edittingUserList[cur];
        if (isShouldAdd) {
          acc.storedEdittingUserList[cur] = 1;
          acc.userListToAdd.push(cur);
        }
        return acc;
      }, {
        storedEdittingUserList: {},
        userListToAdd: [],
      });
      this.props.addUsersToList(userList);
    }
    dispatch(hideModal());
  }

  selectSingleUser() {
    const { parentFormKey, parentFormValues, dispatch, hideModal } = this.props;
    if (parentFormValues && parentFormValues.edittingUserId) {
      this.props.dispatch(change(parentFormKey, 'selectedUserId', parentFormValues.edittingUserId));
    }
    dispatch(hideModal());
  }

  closeModal() {
    const { initial, parentFormKey, parentFormValues, singleSelect } = this.props;
    if (!singleSelect) {
      if (parentFormValues) {
        let { storedEdittingUserList } = parentFormValues;
        if (!storedEdittingUserList) {
          storedEdittingUserList = {};
        }
        this.props.dispatch(change(parentFormKey, 'edittingUserList', storedEdittingUserList));
      }
    } else {
      this.props.dispatch(change(parentFormKey, 'edittingUserId', parentFormValues.selectedUserId));
    }
    this.props.dispatch(this.props.hideModal());
  }

  removeSelectedGroup() {
    this.props.dispatch(change('searchUserForm', 'selectedTargetGroup', null));
    this.props.dispatch(GroupAction.removeSelectedGroup());
  }

  getModalOptions() {
    const { singleSelect } = this.props;
    return {
      title: '',
      footerBtns: [
        { name: 'キャンセル', onClick: this.closeModal },
        {
          name: 'OK',
          onClick: singleSelect ? this.selectSingleUser : this.addUsersToList,
          variant: 'primary',
        },
      ],
    };
  }

  handleChangeCheckbox(event, newValue, previousValue) {
    const { allUserSelected } = this.state;
    const nameCheckbox = event.target.name;
    const userSecernId = nameCheckbox.split('.').pop();
    if (!newValue && previousValue) {
      const pos = allUserSelected.indexOf(userSecernId);
      if (pos > -1) {
        allUserSelected.splice(pos, 1);
      }
    } else {
      allUserSelected.unshift(userSecernId);
    }
    this.setState({ ...this.state, allUserSelected });
  }

  checkUncheckAllUsersOnPage() {
    const { userListOnDialog, maxLength, edittingUserList, parentFormValues } = this.props;
    const { allUserSelected } = this.state;
    if (userListOnDialog && userListOnDialog.length) {
      const checkedUserOnPage = checkUserChecked(edittingUserList, userListOnDialog);
      let storedEdittingUserListArray = [];
      if (parentFormValues && parentFormValues.storedEdittingUserList) {
        storedEdittingUserListArray = Object.keys(parentFormValues.storedEdittingUserList);
      }
      if (checkedUserOnPage.length === userListOnDialog.length) {
        userListOnDialog.map((user) => {
          const { userSecernId } = user;
          const pos = checkedUserOnPage.indexOf(userSecernId);
          const pos2 = storedEdittingUserListArray.indexOf(userSecernId);
          if (pos > -1 && pos2 < 0) {
            this.props.dispatch(change('liveReservedRegisterForm', `edittingUserList.${userSecernId}`, false));
            checkedUserOnPage.splice(pos, 1);
            allUserSelected.splice(pos, 1);
          }
          return null;
        });
        this.setState({ allUserSelected });
        return;
      } else if (allUserSelected.length === maxLength) {
        userListOnDialog.map((user) => {
          const { userSecernId } = user;
          const pos = allUserSelected.indexOf(userSecernId);
          const pos2 = storedEdittingUserListArray.indexOf(userSecernId);
          if (pos > -1 && pos2 < 0) {
            this.props.dispatch(change('liveReservedRegisterForm', `edittingUserList.${userSecernId}`, false));
            allUserSelected.splice(pos, 1);
          }
          return null;
        });
        this.setState({ allUserSelected });
        return;
      }
      for (let i = 0; i < userListOnDialog.length; i++) {
        if (edittingUserList && edittingUserList[userListOnDialog[i].userSecernId] && allUserSelected.length < maxLength) {
          const pos = allUserSelected.indexOf(userListOnDialog[i].userSecernId);
          if (pos < 0) {
            allUserSelected.push(userListOnDialog[i].userSecernId);
          }
        }
      }
      userListOnDialog.map((user) => {
        const { userSecernId } = user;
        const pos = checkedUserOnPage.indexOf(userSecernId);
        const pos2 = allUserSelected.indexOf(userSecernId);
        if (allUserSelected.length < maxLength && pos < 0 && pos2 < 0) {
          allUserSelected.push(userSecernId);
        }
      });
      this.setState({ allUserSelected }, () => {
        if (allUserSelected && allUserSelected.length) {
          allUserSelected.map((userSecernId) => {
            this.props.dispatch(change('liveReservedRegisterForm', `edittingUserList.${userSecernId}`, true));
          });
          return null;
        }
      });
    }
  }

  render() {
    const {
      headerName,
      recordNum,
      userListOnDialog,
      edittingUsers,
      singleSelect,
      groupList,
      selectedTargetGroup,
      withAuthority,
      managementAuthorityList,
      managementAuthoritySecernId,
      withUserAttribute,
      userAttributeKeyNum,
      withGroup,
      withSelectAll,
      maxLength,
      parentFormValues,
    } = this.props;

    return (
      <ModalWrapper temporaryHide={''} {...this.getModalOptions()} hideModal={this.closeModal} title={headerName}>
        <div>
          <UserSearchOnDialog
            onSearchBtnClick={this.searchUser}
            onSubmit={this.searchUserOnSubmit}
            getStartEndData={this.getStartEndData}
            removeSelectedGroup={this.removeSelectedGroup}
            checkUncheckAllUsersOnPage={this.checkUncheckAllUsersOnPage}
            singleSelect={singleSelect}
            {...this.props}
          />
          <UserListOnDialog
            {...parentFormValues}
            getStartEndData={this.getStartEndData}
            userList={userListOnDialog}
            edittingUsers={edittingUsers}
            singleSelect={singleSelect}
            maxLength={maxLength}
            handleChangeCheckbox={this.handleChangeCheckbox}
            {...this.props}
          />
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { selectedTargetGroup, groupList } = state.group;
  const parentForm = state.form[ownProps.parentFormKey];
  const { initial, values } = parentForm;
  const { userListOnDialog, userListDialogRecordNum, storedUserList } = state.user;
  const { authedUser } = state.authed;
  const { user } = state;
  const { edittingUsers } = state[ownProps.parentStoreKey];
  let edittingUserList = {};
  if (parentForm && parentForm.values && parentForm.values.edittingUserList) {
    edittingUserList = parentForm.values.edittingUserList;
  }
  return {
    selectedTargetGroup,
    userListOnDialog,
    edittingUserList,
    edittingUsers,
    parentFormValues: getFormValues(ownProps.parentFormKey)(state),
    recordNum: userListDialogRecordNum,
    initial,
    values,
    groupList,
    formValues: getFormValues('searchUserForm')(state),
    authedUser,
    user,
  };
};

export default connect(mapStateToProps)(SelectUsersContainer);
